import {Algorithm} from "./Algorithm";
import {UserInputOptionSelector} from "./UserInputOptionSelector";

export class Aquilon extends Algorithm {

  constructor(container) {
    super(container);

    this.weatherOverrides = {
      OAT: {
        65: "stormy",
        70: "cloudy",
        75: "sunny",
      }
    };
  }

  buildRangesMap() {
    this.rangesMap = this.userCombinationData.map(({key, title}, index) => {
      const [OAT, SAT] = title.match(/\d+/g).map(Number); // extract numbers from the title
      return {key, OAT, SAT, index};
    });
  }

  initUserInputs() {
    super.initUserInputs();

    this.outdoorTemperatureSelector = new UserInputOptionSelector(this.$container.find(`.user-input-selector-container[data-user-input-id="OAT"]`));
    this.outdoorTemperatureSelector.on("userInputValueChanged", (value) => this.onUserInput(value));

    this.supplyAirTemperatureSelector = new UserInputOptionSelector(this.$container.find(`.user-input-selector-container[data-user-input-id="SAT"]`));
    this.supplyAirTemperatureSelector.on("userInputValueChanged", (value) => this.onUserInput(value));
  }

  onUserInput(value) {
    const targetCombination = this.findUserCombination(this.outdoorTemperatureSelector.getRealValue(), this.supplyAirTemperatureSelector.getRealValue());

    // Update KPIs
    this.selectKPIs(targetCombination.key);

    // Update charts
    Object.entries(this.charts).forEach(([name, chart]) => {
      chart.loadDataset(targetCombination.index);
    });

    this.decisionLogs.update(this.currentKPIKey, this.buildingSelector.currentBuilding);

    this.sendWeatherOverride();
  }

  sendWeatherOverride() {
    if (!this.isActive) return;

    const OAT = this.outdoorTemperatureSelector.getRealValue();

    app.sendScreenBridgeMessage(`weatherOverride ${this.weatherOverrides.OAT[OAT] ?? "none"}`);
  }

  findUserCombination(OAT, SAT) {
    // Let's return the entry where the value fits the correct values
    // Returns the first element if there is no match (which should not happen if data is set correctly)
    return this.rangesMap.find(entry => entry.OAT === OAT && entry.SAT === SAT) ?? this.rangesMap[0];
  }

  start() {
    super.start();

    this.sendWeatherOverride();
  }

  resetUserInputs() {
    this.outdoorTemperatureSelector.reset();
    this.supplyAirTemperatureSelector.reset();
  }

}
